export const selectDataBus = (state: any): any => state.dataBus;
